import Highcharts from 'highcharts';

export default function chartFire(chartId) {
    if (!document.getElementById(chartId)) return;

    Highcharts.chart(chartId, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Utrudnienia dojazdu Państwowej Straży Pożarnej w 2025 r.'
        },
        xAxis: {
            categories: ['Pożary', 'Miejscowe zagrożenia'],
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Liczba utrudnień dojazdu'
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: 'Liczba utrudnień dojazdu: <b>{point.y}</b>'
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Utrudnienia dojazdu',
            data: [
                { y: 1355, color: '#e74c3c' },
                { y: 2143, color: '#f39c12' }
            ],
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: '14px'
                }
            }
        }]
    });
}
